import script from "./Flota_PreLOP_Unidades_Nuevas.vue?vue&type=script&setup=true&lang=js"
export * from "./Flota_PreLOP_Unidades_Nuevas.vue?vue&type=script&setup=true&lang=js"

import "./Flota_PreLOP_Unidades_Nuevas.vue?vue&type=style&index=0&id=4b17827e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b17827e"]])

export default __exports__